function numberWithZero(num) {
  if (num < 10) {
    return "0" + num;
  } else {
    return num;
  }
}

// $(".hero").each(function (index) {
//   let totalSlides = numberWithZero($(this).find(".swiper-slide.hero-swiper").length);
//   $(".swiper-number-total").text(totalSlides);
//   const swiperHero = new Swiper($(this).find(".swiper.hero-swiper")[0], {
//     slidesPerView: 1,
//     speed: 800,
//     loop: true,
//     effect: 'fade',
//     autoplay: {
//      delay: 9000,
//    },
//     pagination: {
//       el: $(this).find(".swiper-pagination")[0],
//       type: 'bullets',
//       clickable: true,
//     },
//   });
//   swiperHero.on("slideChange", function (e) {
//     let slideNumber = numberWithZero(e.realIndex + 1);
//     $(".swiper-number-current").text(slideNumber);
//   });
// });

// var swiperPDP = new Swiper(".swiper.pdp-swiper", {
//   slidesPerView: 1,
//   spaceBetween: 10,
//   rewind: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   pagination: {
//     el: '.swiper-pagination',
//     type: 'bullets',
//     clickable: 'true',
//   },
//   breakpoints: {
//     479: {
//       slidesPerView: 2
//     }
//   }
// });

// Initialize thumbnail swiper first
var swiperPDPThumbs = new Swiper(".pdp-thumb-swiper", {
  slidesPerView: 'auto',
  spaceBetween: 10,
  watchSlidesProgress: true,
  allowTouchMove: true,
  centerInsufficientSlides: true,
  width: null
});

// Function to set initial active states
function initializeVariantThumbnails() {
  // Get all unique thumbnail-alt values (colors)
  const uniqueColors = new Set(
    Array.from(document.querySelectorAll('.pdp-thumb-swiper .swiper-slide'))
      .map(thumb => thumb.getAttribute('thumbnail-alt'))
      .filter(Boolean)
  );

  // Clear all active states first
  document.querySelectorAll('.pdp-thumb-swiper .swiper-slide').forEach(thumb => {
    thumb.classList.remove('swiper-slide-thumb-active');
  });

  // For each color, set the first thumbnail as active
  uniqueColors.forEach(color => {
    const colorThumbs = Array.from(
      document.querySelectorAll(`.pdp-thumb-swiper .swiper-slide[thumbnail-alt="${color}"]`)
    );
    if (colorThumbs.length > 0) {
      colorThumbs[0].classList.add('swiper-slide-thumb-active');
    }
  });
}

document.addEventListener('click', function (event) {
  // Check if the clicked element is a swatch label
  const swatch = event.target.closest('.color-swatches .swatch-input__label');
  if (!swatch) return;

  event.preventDefault();

  // Get the closest product card for the clicked swatch
  const productCard = swatch.closest('.product-card');
  if (!productCard) return;

  // Get the variant details from the clicked swatch
  const variantUrl = swatch.getAttribute('data-variant-url');
  const variantImage = swatch.getAttribute('data-variant-image');

  // Update the product image within the same product card
  const productImage = productCard.querySelector('img.product-card-image');
  if (productImage) {
    productImage.src = variantImage;
  }

  // Update the product URL within the same product card
  const productLink = productCard.querySelector('a');
  if (productLink) {
    productLink.href = variantUrl;
  }

  // Update the active class on swatch labels within the same product card
  productCard.querySelectorAll('.swatch-input__label').forEach(label => {
    label.classList.remove('active'); // Remove active class from all labels
  });
  swatch.classList.add('active'); // Add active class to the clicked label
});

// Modify the existing PDP swiper
var swiperPDP = new Swiper(".swiper.pdp-swiper", {
  slidesPerView: 1,
  grabCursor: true,
  mousewheel: {
    invert: false,
    forceToAxis: true },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  breakpoints: {
    600: {
      slidesPerView: 2,
      spaceBetween: 7
    }
  },
  on: {
    init: function() {
      initializeVariantThumbnails();
      this.update();
    }
  }
});

// Update active thumbnail when swiper changes
swiperPDP.on('slideChange', function() {
  const visibleThumbs = Array.from(document.querySelectorAll('.pdp-thumb-swiper .swiper-slide'))
    .filter(thumb => thumb.style.display !== 'none');

  visibleThumbs.forEach((thumb, index) => {
    thumb.classList.toggle('swiper-slide-thumb-active', index === this.activeIndex);
  });

  // Ensure active slide is visible
  requestAnimationFrame(() => {
    const activeSlide = document.querySelector('.pdp-swiper .swiper-slide-active');
    if (activeSlide) {
      activeSlide.style.opacity = '1';
      activeSlide.style.visibility = 'visible';
    }
  });
});

// Simple click handler for thumbnails
document.querySelectorAll('.pdp-thumb-swiper .swiper-slide').forEach((thumb) => {
  thumb.addEventListener('click', () => {
    const visibleThumbs = Array.from(document.querySelectorAll('.pdp-thumb-swiper .swiper-slide'))
      .filter(t => t.style.display !== 'none');

    const thumbIndex = visibleThumbs.indexOf(thumb);
    if (thumbIndex !== -1) {
      swiperPDP.slideTo(thumbIndex);

      // Force opacity update on the new active slide
      requestAnimationFrame(() => {
        const activeSlide = document.querySelector('.pdp-swiper .swiper-slide-active');
        if (activeSlide) {
          activeSlide.style.opacity = '1';
          activeSlide.style.visibility = 'visible';
        }
      });
    }
  });
});

// Add variant change handler
document.addEventListener('variant:changed', function(event) {
  const variant = event.detail.variant;
  if (variant?.featured_image?.alt) {
    requestAnimationFrame(() => {
      // Reset all first thumbnails for each color variant
      initializeVariantThumbnails();

      // Reset swiper position and update
      swiperPDP.slideTo(0, 0);
      swiperPDP.update();

      // Force opacity update on visible slides
      document.querySelectorAll('.pdp-swiper .swiper-slide').forEach(slide => {
        if (slide.style.display !== 'none') {
          slide.style.opacity = '1';
        } else {
          slide.style.opacity = '0';
        }
      });
    });
  }
});

var swiperProductFeatures = new Swiper(".swiper.product-features-swiper", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  resizeReInit: true,
  freeMode: true,
  freeModeFluid: true,
  scrollContainer: true,
  grabCursor: true,
  mousewheel: {
    invert: false,
    forceToAxis: true },
  slidesPerView: 1.3,
  breakpoints: {
    768: {
      slidesPerView: 2.3
    },
    1200: {
      slidesPerView: 3.3,
      spaceBetween: 20,
    },
    1700: {
      slidesPerView: 4,
      spaceBetween: 20,
    }
  }
});

var swiperBlog = new Swiper(".swiper.blog-swiper", {
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  resizeReInit: true,
  freeMode: true,
  freeModeFluid: true,
  scrollContainer: true,
  grabCursor: true,
  mousewheel: {
    invert: false,
    forceToAxis: true },
  slidesPerView: 1.3,
  breakpoints: {
    768: {
      slidesPerView: 2.3
    },
    1200: {
      slidesPerView: 5
    }
  }
});

var swiperQuote = new Swiper(".swiper.quote-swiper", {
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  breakpoints: {
    479: {
      slidesPerView: 2
    },
    768: {
      slidesPerView: 3
    }
  }
});

var swiperQuote = new Swiper(".swiper.quote-swiper-rev", {
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  }
});

var swatchSlider = new Swiper(".swiper.swatches", {
  slidesPerView: 'auto',
  spaceBetween: 3,
  freeMode: {
    enabled: true,
    momentum: false,
    sticky: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  watchOverflow: true, // disables Swiper nav when slides fit
  on: {
    afterInit(swiper) {
      toggleArrows(swiper);
    },
    resize(swiper) {
      toggleArrows(swiper);
    }
  },
});

function toggleArrows(swiper) {
  const colorSwatches = swiper.el.closest('.color-swatches');
  console.log(colorSwatches)
  if (!colorSwatches) return;

  const prev = swiper.el.querySelector('.swiper-button-prev');
  const next = swiper.el.querySelector('.swiper-button-next');
  const tooManySlides = swiper.wrapperEl.scrollWidth > swiper.el.clientWidth;

  if (tooManySlides) {
    colorSwatches.classList.add('has-arrows');
    prev.style.display = next.style.display = 'block';
  } else {
    colorSwatches.classList.remove('has-arrows');
    prev.style.display = next.style.display = 'none';
  }
}

var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
  // Set first accordion item as active by default
  if (i === 0) {
    acc[i].classList.add("active");
    var firstPanel = acc[i].nextElementSibling;
    if (firstPanel) {
      firstPanel.style.display = "block";
    }
  }

  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");
    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

var triggerSearch = document.getElementById("trigger-search");
if (triggerSearch) {
  triggerSearch.onclick = function toggleSearch() {
    var search = document.getElementById("search");
    if (search) {
      search.classList.toggle("open"); // toggles open/close
      if (search.classList.contains("open")) {
        // focus the input when opened
        var input = search.querySelector(".search-input");
        if (input) input.focus();
      }
    }
  };
}

var triggerSearchMobile = document.getElementById("trigger-search-mobile");
if (triggerSearchMobile) {
  triggerSearchMobile.onclick = function openSearch() {
    var search = document.getElementById("search-mobile");
    if (search) {
      search.classList.toggle("open"); // toggles open/close
      if (search.classList.contains("open")) {
        // focus the input when opened
        var input = search.querySelector(".search-input");
        if (input) input.focus();
      }
    }
  };
}

var searchClose = document.getElementById("search-close");
if (searchClose) {
  searchClose.onclick = function closeSearch() {
    var search = document.getElementById("search");
    if (search) {
      search.classList.remove("open");
    }
  };
}

var sizeChartOpen = document.getElementById("size-chart-open");
if (sizeChartOpen) {
  sizeChartOpen.onclick = function openShare() {
    var sizeChart = document.getElementById("size-chart");
    if (sizeChart) {
      sizeChart.classList.add("open");
    }
  };
}

var sizeChartClose = document.getElementById("size-chart-close");
if (sizeChartClose) {
  sizeChartClose.onclick = function closeShare() {
    var sizeChart = document.getElementById("size-chart");
    if (sizeChart) {
      sizeChart.classList.remove("open");
    }
  };
}

$(document).ready(function() {
  $('[data-fancybox]').fancybox({
      idleTime: false,
      animationEffect: "fade",
      buttons: [
        "close"
      ]
  });
})

// Script to help with the drop down navigation
document.addEventListener('DOMContentLoaded', function() {
  const dropdowns = document.querySelectorAll('.nav-container .nav-dropdown');

  function handleResponsiveLayout() {
    const isMobile = window.innerWidth < 991;

    // Handle dropdown positioning on desktop only
    if (!isMobile) {
      dropdowns.forEach(dropdown => {
        // Remove any previous alignment classes
        dropdown.classList.remove('align-right');

        const dropdownContent = dropdown.querySelector('.dropdown-content');
        const rect = dropdown.getBoundingClientRect();
        const windowWidth = window.innerWidth;

        // Check if dropdown would extend beyond the right edge of the window
        if (rect.left + dropdownContent.offsetWidth > windowWidth - 20) {
          dropdown.classList.add('align-right');
        }
      });
    }

    // Mobile-specific behavior
    if (isMobile) {
      // Open the active dropdown if it exists
      dropdowns.forEach(dropdown => {
        const link = dropdown.querySelector('.nav-link');
        const content = dropdown.querySelector('.dropdown-content');

        // If this dropdown has the active class or contains an active child, open it and add active class
        if (link.classList.contains('active') || dropdown.querySelector('.dropdown-link.active')) {
          content.classList.add('is-active');
          link.classList.add('active'); // Ensure parent link has active class
        }
      });
    }
  }

  // Run on page load
  handleResponsiveLayout();

  // Run on window resize
  window.addEventListener('resize', handleResponsiveLayout);

  // Add click handlers for mobile
  dropdowns.forEach(dropdown => {
    const link = dropdown.querySelector('.nav-link');
    const content = dropdown.querySelector('.dropdown-content');

    link.addEventListener('click', function(e) {
      // Only prevent default on mobile
      if (window.innerWidth < 991) {
        e.preventDefault();

        // Toggle current dropdown without closing others
        content.classList.toggle('is-active');
      }
      // On desktop, let the default link behavior work
    });
  });
});

// Simple cart empty class handler to make sure cart messaging is centered.
document.addEventListener('DOMContentLoaded', function() {
  function updateCartEmptyClass() {
    const isEmpty = document.querySelector('.cart-empty-message') !== null ||
                   document.querySelector('.cart-item') === null;

    document.body.classList.toggle('is-empty', isEmpty);
    document.body.classList.toggle('not-empty', !isEmpty);
  }

  // Run on page load
  updateCartEmptyClass();

  // Listen for cart update events
  document.addEventListener('cart:updated', updateCartEmptyClass);

  // Watch for DOM changes in the cart container
  const cartContainer = document.querySelector('.cart-container, #cart');
  if (cartContainer) {
    new MutationObserver(updateCartEmptyClass).observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }

  // Listen for clicks on remove buttons
  document.body.addEventListener('click', function(e) {
    if (e.target.closest('.cart-remove')) {
      setTimeout(updateCartEmptyClass, 300);
    }
  });
});


// document.addEventListener('DOMContentLoaded', function() {
//   const dropdowns = document.querySelectorAll('.nav-dropdown');

//   dropdowns.forEach(dropdown => {
//     const dropdownContent = dropdown.querySelector('.dropdown-content');
//     const rect = dropdown.getBoundingClientRect();
//     const windowWidth = window.innerWidth;

//     // If dropdown would overflow the right side
//     if (rect.left + dropdownContent.offsetWidth > windowWidth - 20) { // 20px buffer
//       dropdown.classList.add('align-right');
//     }
//   });
// });